if (!customElements.get("ashpveda-offer-picker")) {
  customElements.define(
    "ashpveda-offer-picker",
    class AshpvedaOfferPicker extends HTMLElement {
      connectedCallback() {
        /*
         * The custom picker is placed inside Ashpveda's
         * existing <variant-options> element.
         */
        this.variantOptions = this.closest("variant-options");

        this.cards = Array.from(this.querySelectorAll(".ashpveda-offer-card"));

        if (!this.variantOptions || !this.cards.length) {
          return;
        }

        this.handleVariantChange = this.handleVariantChange.bind(this);

        this.cards.forEach((card) => {
          card.addEventListener("click", () => {
            this.selectCard(card);
          });
        });

        /*
         * variants.js dispatches these events around every
         * variant update.
         */
        this.variantOptions.addEventListener(
          "variantChangeEnd",
          this.handleVariantChange,
        );

        this.variantOptions.addEventListener(
          "change",
          this.handleVariantChange,
        );

        this.syncFromNativePicker();
      }

      disconnectedCallback() {
        this.variantOptions?.removeEventListener(
          "variantChangeEnd",
          this.handleVariantChange,
        );

        this.variantOptions?.removeEventListener(
          "change",
          this.handleVariantChange,
        );
      }

      selectCard(card) {
        if (card.disabled || card.classList.contains("is-disabled")) {
          return;
        }

        const optionValue = card.dataset.optionValue;

        /*
         * Ashpveda's native variant radio buttons are inside
         * .wt-product__option.
         */
        const inputs = Array.from(
          this.variantOptions.querySelectorAll(
            '.wt-product__option input[type="radio"]',
          ),
        );

        const matchingInput = inputs.find((input) => {
          return input.value === optionValue;
        });

        if (!matchingInput) {
          console.warn(
            "[Ashpveda offer picker] Matching variant option was not found.",
            {
              optionValue,
            },
          );

          return;
        }

        /*
         * Clicking the original input triggers variants.js.

         * variants.js then handles:
         * - current variant
         * - main product image
         * - price
         * - inventory
         * - URL
         * - hidden product form variant ID
         * - Add to Cart availability
         */
        matchingInput.click();

        this.setSelected(card);
      }

      handleVariantChange() {
        window.requestAnimationFrame(() => {
          this.syncFromNativePicker();
        });
      }

      syncFromNativePicker() {
        const checkedInput = this.variantOptions.querySelector(
          '.wt-product__option input[type="radio"]:checked',
        );

        if (!checkedInput) return;

        const selectedCard = this.cards.find((card) => {
          return card.dataset.optionValue === checkedInput.value;
        });

        if (selectedCard) {
          this.setSelected(selectedCard);
        }
      }

      setSelected(selectedCard) {
        this.cards.forEach((card) => {
          const isSelected = card === selectedCard;

          card.classList.toggle("is-selected", isSelected);

          card.setAttribute("aria-checked", String(isSelected));
        });

        this.dataset.selectedVariantId = selectedCard.dataset.variantId || "";
      }
    },
  );
}
